import { render, staticRenderFns } from "./DialogEditTaxe.vue?vue&type=template&id=7f96f85c"
import script from "./DialogEditTaxe.vue?vue&type=script&lang=js"
export * from "./DialogEditTaxe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports